// =========================
// INIT GLOBAL PRODUCTS
// =========================
if (!window.products) {
  const raw = localStorage.getItem('compare-products');
  window.products = raw ? raw.split(',') : [];
}

function initCompareButtons() {
  const list = window.products || [];

  document.querySelectorAll('.btn-add-to-compare').forEach((btn) => {
    const handle = btn.dataset.handle;
    if (!handle) return;

    btn.textContent = list.includes(handle)
      ? 'Remove To Compare'
      : 'Add To Compare';
  });
}

// =========================
// ADD TO COMPARE
// =========================
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn-add-to-compare');
  if (!btn) return;

  const handle = btn.dataset.handle;
  if (!handle) return;

  let list = window.products || [];
  const isAdded = list.includes(handle);

  const title =
    btn.dataset.title ||
    btn.closest('[data-product-card]')?.querySelector('.c-product-card__title')?.textContent ||
    '';

  if (isAdded) {
    list = list.filter(p => p !== handle);

    toast({
      message: `You removed product <span>${title}</span>`,
      type: 'success',
      duration: 3000
    });

  } else {
    if (list.length > 2) list.shift();

    list.push(handle);

    toast({
      message: `You added product <span>${title}</span> to the <a href="${window.location.origin}/pages/compare">comparison list</a>.`,
      type: 'success',
      duration: 5000
    });
  }

  // save
  localStorage.setItem('compare-products', list.join(','));
  window.products = list;

  // =========================
  // UPDATE ALL BUTTON STATE
  // =========================
  initCompareButtons();

  if (window.Alpine) {
    Alpine.store('compare').products = [...list];
  }
});

window.CProductCard = (() => {

  // =========================
  // helpers
  // =========================
  function formatPrice(price) {
    return theme?.Currency
      ? theme.Currency.formatMoney(price)
      : price;
  }

  function getMaxSwatches() {
    return window.matchMedia('(max-width: 767px)').matches ? 4 : 6;
  }

  // Find which option is the colour one ("Color"/"Colour") so 2-option
  // products (e.g. Size + Color) read the colour value from the right index
  // instead of always assuming option1. Returns -1 when there's no colour option.
  function getColorOptionIndex(product) {
    const names = (product.options || []).map(o =>
      typeof o === 'string' ? o : (o && o.name) || ''
    );
    return names.findIndex(n => /colou?r/i.test(n));
  }

  // --- Multi-option (size) support ----------------------------------------
  // Colour is shown as swatches; every OTHER option (e.g. Size) gets a <select>
  // so the customer can pick a full variant before add-to-cart.
  function getOptionNames(product) {
    return (product.options || []).map(o =>
      typeof o === 'string' ? o : (o && o.name) || ''
    );
  }

  function getOptionValue(variant, idx) {
    if (variant.options && variant.options[idx] != null) return variant.options[idx];
    return variant['option' + (idx + 1)];
  }

  // The option rendered as colour swatches (colour if present, else 1st option).
  function getSwatchOptionIndex(product) {
    const ci = getColorOptionIndex(product);
    return ci >= 0 ? ci : 0;
  }

  // Option indexes that need a <select> (everything except the swatch option).
  function getSelectOptionIndexes(product) {
    const swatchIdx = getSwatchOptionIndex(product);
    const count = getOptionNames(product).length;
    const idxs = [];
    for (let i = 0; i < count; i++) if (i !== swatchIdx) idxs.push(i);
    return idxs;
  }

  // Resolve the exact variant for a colour + the chosen <select> values.
  function resolveVariant(product, color, selected) {
    const swatchIdx = getSwatchOptionIndex(product);
    return (product.variants || []).find(v => {
      if (getOptionValue(v, swatchIdx) !== color) return false;
      return Object.keys(selected).every(i => getOptionValue(v, Number(i)) === selected[i]);
    });
  }

  // Unique values of option `idx` among variants matching `context`
  // (a map of optionIndex -> value). Each value carries availability.
  function optionValuesForContext(product, idx, context) {
    const keys = Object.keys(context);
    const seen = new Map(); // value -> available
    (product.variants || []).forEach(v => {
      if (!keys.every(k => getOptionValue(v, Number(k)) === context[k])) return;
      const val = getOptionValue(v, idx);
      if (val == null) return;
      if (!seen.has(val)) seen.set(val, false);
      if (v.available) seen.set(val, true);
    });
    return Array.from(seen, ([value, available]) => ({ value, available }));
  }

  // Build one <select> per non-colour option. Options CASCADE: each select is
  // filtered by the colour + the selections of the options before it, so a
  // 3-option product (Color + Size + Material) only ever offers combinations
  // that actually exist. `prefs` keeps the user's current choices on rebuild.
  function buildSizeSelects(product, color, prefs) {
    prefs = prefs || {};
    const swatchIdx = getSwatchOptionIndex(product);
    const names = getOptionNames(product);
    const chosen = {};
    chosen[swatchIdx] = color;

    return getSelectOptionIndexes(product).map(idx => {
      const values = optionValuesForContext(product, idx, chosen);
      if (!values.length) return '';

      // Keep the user's current choice even if it's sold out; only auto-pick when
      // there's no valid choice yet (initial / colour changed) — then prefer an
      // in-stock value so the card opens on an available size.
      let selected = prefs[idx];
      if (!values.some(o => o.value === selected)) {
        const firstAvail = values.find(o => o.available);
        selected = firstAvail ? firstAvail.value : values[0].value;
      }
      chosen[idx] = selected;

      // Sold-out values stay SELECTABLE (no `disabled`) — picking one flips the
      // add-to-cart button to "Sold out" (see applyVariant → update).
      const optionsHtml = values.map(o =>
        `<option value="${o.value}"${o.value === selected ? ' selected' : ''}>${o.value}${o.available ? '' : ' — sold out'}</option>`
      ).join('');

      return `<select class="c-product-card__size-select" data-size-select data-option-index="${idx}" aria-label="${names[idx] || 'Option'}">${optionsHtml}</select>`;
    }).join('');
  }

  // Read current <select> choices so a rebuild can preserve them where valid.
  function readSizePrefs(card) {
    const prefs = {};
    card.querySelectorAll('[data-size-select]').forEach(sel => {
      prefs[sel.dataset.optionIndex] = sel.value;
    });
    return prefs;
  }

  // (Re)render the cascading size select(s) for a colour, preserving current
  // choices where they stay valid.
  function renderSizes(card, product, color) {
    const holder = card.querySelector('[data-sizes]');
    if (!holder) return;
    holder.innerHTML = buildSizeSelects(product, color, readSizePrefs(card));
  }

  // Sync price / image / add-to-cart variant to the active colour + sizes.
  function applyVariant(card, product) {
    const activeSwatch = card.querySelector('.color-swatch.is-active') ||
                         card.querySelector('.color-swatch');
    const color = activeSwatch ? activeSwatch.getAttribute('title') : null;

    const selected = {};
    card.querySelectorAll('[data-size-select]').forEach(sel => {
      selected[sel.dataset.optionIndex] = sel.value;
    });

    const variant = resolveVariant(product, color, selected) || {};

    update(card, {
      price: Number(variant.price || 0),
      comparePrice: Number(variant.compare_at_price || 0),
      image: activeSwatch
        ? activeSwatch.dataset.image
        : normalizeImage(variant.featured_image?.src || product.featured_image),
      variantId: variant.id,
      available: variant.available
    });
  }

  function normalizeImage(src) {
    if (!src) return '';
    return src.replace(/^\/\//, 'https://');
  }

  // =========================
  // build swatches
  // =========================
  function buildSwatches(product) {
    const max = getMaxSwatches();
    const colorIndex = getColorOptionIndex(product);

    // Dedupe available variants by colour value so a 2-option product shows
    // one swatch per colour, not one swatch per variant (colour × size).
    const seen = new Set();
    const colorVariants = [];

    (product.variants || []).forEach(v => {
      if (!v.available) return;

      const color = (colorIndex >= 0 ? v.options?.[colorIndex] : v.option1) || '';
      const key = color.toLowerCase().trim();
      if (!key || seen.has(key)) return;

      seen.add(key);
      colorVariants.push({ variant: v, color });
    });

    let visible = '';
    let hidden = '';

    colorVariants.forEach(({ variant: v, color }, i) => {
      const handle = color.toLowerCase().replace(/\s+/g, '-');

      const image = normalizeImage(
        v.featured_image?.src || product.featured_image
      );

      const colorImage = `/cdn/shop/files/${handle}.png`;

      const swatch = `
        <span class="color-swatch"
          data-swatch
          data-image="${image}"
          data-price="${v.price}"
          data-compare-price="${v.compare_at_price || ''}"
          data-variant-id="${v.id}"
          data-available="${v.available}"
          title="${color}"
          style="
            background-color:${color.toLowerCase()};
            background-image:url('${colorImage}');
            background-size:cover;
            background-position:center;
          ">
        </span>
      `;

      if (i < max) visible += swatch;
      else hidden += swatch;
    });

    const more = colorVariants.length > max
      ? `<span class="swatch-more" data-swatch-more>+${colorVariants.length - max}</span>`
      : '';

    return `
      <div class="c-product-card__swatches">
        ${visible}
        ${more}
        <div class="c-product-card__popover">
          ${hidden}
        </div>
      </div>
    `;
  }

  // =========================
  // create card
  // =========================
  function create(product) {
    const variants = product.variants || [];
    // Default to the first in-stock variant so the card's price/button match
    // the visible (available-only) swatches. Fall back to variants[0] when the
    // whole product is sold out.
    const first = variants.find(v => v.available) || variants[0] || {};

    const image = normalizeImage(
      first.featured_image?.src || product.featured_image
    );

		const safeTitle = product.title.replace(/"/g, '&quot;');
		const safeHandle = product.handle;

    const el = document.createElement('div');
    el.className = 'c-product-card';
    el.setAttribute('data-product-card', '');

    el.innerHTML = `
      <div class="c-product-card__image-wrapper">
        <a href="/products/${product.handle}">
          <img class="c-product-card__image" src="${image}" alt="${product.title}">
        </a>
      </div>

      <h4 class="c-product-card__title">
        <a href="/products/${product.handle}">
          ${product.title}
        </a>
      </h4>

      <div class="c-product-card__price">
        <span class="price-compare"></span>
        <span class="price-final"></span>
      </div>

      <div class="c-product-card__sizes" data-sizes></div>

      ${buildSwatches(product)}

      <button
        class="c-product-card__btn btn-add-to-cart"
        data-add-to-cart
        data-variant-id="${first.id || ''}">
        Add to cart
      </button>

      <button
        class="btn-add-to-compare"
        data-handle="${product.handle}"
        data-title="${product.title}">
        Add To Compare
      </button>
    `;

    // init state
    update(el, {
      price: Number(first.price || 0),
      comparePrice: Number(first.compare_at_price || 0),
      image,
      variantId: first.id,
      available: first.available
    });

    // set active swatch đầu tiên
    const firstSwatch = el.querySelector('.color-swatch');
    if (firstSwatch) firstSwatch.classList.add('is-active');

    // Multi-option products: render the size select(s) for the first colour and
    // sync the add-to-cart variant to colour + first in-stock size.
    el._product = product;
    if (firstSwatch) {
      renderSizes(el, product, firstSwatch.getAttribute('title'));
      applyVariant(el, product);
    }

    const btn = el.querySelector('.btn-add-to-compare');
    if (btn) {
      const list = window.products || [];

      btn.textContent = list.includes(product.handle)
        ? 'Remove To Compare'
        : 'Add To Compare';
    }

    return el;
  }

  // =========================
  // update UI
  // =========================
  function update(card, data) {
    const img = card.querySelector('.c-product-card__image');
    const priceEl = card.querySelector('.c-product-card__price');
    const btn = card.querySelector('[data-add-to-cart]');

    if (img && data.image) img.src = data.image;

    if (priceEl) {
      const compareEl = priceEl.querySelector('.price-compare');
      const finalEl = priceEl.querySelector('.price-final');

      const price = Number(data.price || 0);
      const compare = Number(data.comparePrice || 0);

      if (compare && compare > price) {
        compareEl.innerHTML = formatPrice(compare);
        compareEl.style.display = 'inline-block';
        compareEl.style.textDecoration = 'line-through';
        compareEl.style.marginRight = '6px';

        finalEl.innerHTML = formatPrice(price);
      } else {
        compareEl.style.display = 'none';
        finalEl.innerHTML = formatPrice(price);
      }
    }

    if (btn) {
      btn.dataset.variantId = data.variantId;
      btn.disabled = !data.available;
      btn.textContent = data.available ? 'Add to cart' : 'Sold out';
    }
  }

  // =========================
  // bind events
  // =========================
  function bind(root = document) {

    root.addEventListener('click', async (e) => {

      // ===== SWATCH CLICK =====
      const swatch = e.target.closest('[data-swatch]');
      if (swatch) {
        const card = swatch.closest('[data-product-card]');
        const color = swatch.getAttribute('title');

        card.querySelectorAll('.color-swatch')
          .forEach(s => s.classList.remove('is-active'));

        swatch.classList.add('is-active');

        // swap nếu trong popover
        if (swatch.closest('.c-product-card__popover')) {
          const visible = card.querySelectorAll(
            '.c-product-card__swatches > .color-swatch'
          );

          const last = visible[visible.length - 1];

          if (last) {
            const a = swatch.cloneNode(true);
            const b = last.cloneNode(true);

            last.replaceWith(a);
            swatch.replaceWith(b);
          }

          card.querySelector('.c-product-card__popover')
            ?.classList.remove('is-open');
        }

        // Rebuild the size select(s) for the new colour, then sync the variant.
        const product = card._product;
        if (product) {
          renderSizes(card, product, color);
          applyVariant(card, product);
        } else {
          update(card, {
            price: Number(swatch.dataset.price || 0),
            comparePrice: Number(swatch.dataset.comparePrice || 0),
            image: swatch.dataset.image,
            variantId: swatch.dataset.variantId,
            available: swatch.dataset.available === 'true'
          });
        }

        return;
      }

      // ===== MORE CLICK =====
      const more = e.target.closest('[data-swatch-more]');
      if (more) {
        const card = more.closest('[data-product-card]');
        card.querySelector('.c-product-card__popover')
          ?.classList.toggle('is-open');
        return;
      }

      // ===== CLICK OUTSIDE CLOSE =====
      if (!e.target.closest('.c-product-card__popover') &&
          !e.target.closest('[data-swatch-more]')) {

        document.querySelectorAll('.c-product-card__popover')
          .forEach(p => p.classList.remove('is-open'));
      }

      // ===== ADD TO CART =====
      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) {
        const id = btn.dataset.variantId;
        if (!id) return;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity: 1 })
          });

          if (!res.ok) throw new Error('Add to cart failed');

          window.location.href = '/cart';

        } catch (err) {
          console.error(err);
        }
      }

    });

    // ===== SIZE SELECT CHANGE =====
    root.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-size-select]');
      if (!sel) return;

      const card = sel.closest('[data-product-card]');
      if (!card || !card._product) return;

      // Re-cascade the downstream select(s) for the new choice, then sync.
      const activeSwatch = card.querySelector('.color-swatch.is-active') ||
                           card.querySelector('.color-swatch');
      renderSizes(card, card._product, activeSwatch ? activeSwatch.getAttribute('title') : null);
      applyVariant(card, card._product);
    });
  }

  // =========================
  // public API
  // =========================
  return {
    create,
    update,
    bind
  };

})();
